/**
 * Magnolia Delivery Scheduler — JS mínimo
 *
 * El servidor (Liquid) ya pre-calculó qué días están disponibles. Este JS:
 *  - Maneja clicks (comuna / día / slot)
 *  - Persiste a cart.attributes vía /cart/update.js
 *  - Bloquea checkout si faltan los 3 campos
 *  - NO calcula fechas — eso lo hace el server
 *
 * Validación de cutoff en cliente: usa Intl.DateTimeFormat('America/Santiago')
 * para no depender del TZ del dispositivo. Es el último filtro antes del checkout.
 */
(function () {
  'use strict';

  function initScheduler(root) {
    if (root.__mgSchedInited) return;
    root.__mgSchedInited = true;

    var configEl = root.querySelector('[data-mg-sched-config]');
    var config = {};
    try { config = JSON.parse(configEl.textContent); } catch (e) {}

    var comunaSel = root.querySelector('[data-mg-sched-comuna]');
    var dateInput = root.querySelector('[data-mg-sched-date]');
    var slotInput = root.querySelector('[data-mg-sched-slot]');
    var slotsWrap = root.querySelector('[data-mg-sched-slots-wrap]');
    var slotManana = root.querySelector('[data-slot-name="manana"]');
    var slotTarde = root.querySelector('[data-slot-name="tarde"]');
    var msgEl = root.querySelector('[data-mg-sched-message]');

    syncSlotsForDate(dateInput.value);

    comunaSel.addEventListener('change', function () {
      updateCart('Comuna de Entrega', comunaSel.value);
      comunaSel.classList.remove('is-error');
    });

    root.querySelectorAll('.mg-sched__day.is-available').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var date = btn.getAttribute('data-date');
        root.querySelectorAll('.mg-sched__day.is-selected').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        dateInput.value = date;
        updateCart('Fecha de Entrega', date);

        if (slotInput.value && needToClearSlot(date, slotInput.value)) {
          slotInput.value = '';
          updateCart('Horario de Entrega', '');
          root.querySelectorAll('.mg-sched__slot.is-selected').forEach(function (b) {
            b.classList.remove('is-selected');
          });
        }

        syncSlotsForDate(date);
        slotsWrap.removeAttribute('hidden');
        hideMessage();
      });
    });

    [slotManana, slotTarde].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var slotValue = btn.getAttribute('data-slot');
        root.querySelectorAll('.mg-sched__slot.is-selected').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        slotInput.value = slotValue;
        updateCart('Horario de Entrega', slotValue);
        hideMessage();
      });
    });

    function syncSlotsForDate(date) {
      if (!slotManana || !slotTarde) return;
      if (!date) {
        slotsWrap.setAttribute('hidden', '');
        return;
      }
      slotsWrap.removeAttribute('hidden');
      var isToday = (date === config.todayChile);
      slotManana.disabled = isToday;
      if (isToday && slotManana.classList.contains('is-selected')) {
        slotManana.classList.remove('is-selected');
      }
    }

    function needToClearSlot(newDate, currentSlotValue) {
      var isToday = (newDate === config.todayChile);
      if (isToday && currentSlotValue.indexOf('Mañana') !== -1) return true;
      return false;
    }

    function showError(text) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.className = 'mg-sched__message is-error';
      msgEl.removeAttribute('hidden');
    }

    function hideMessage() {
      if (!msgEl) return;
      msgEl.textContent = '';
      msgEl.className = 'mg-sched__message';
      msgEl.setAttribute('hidden', '');
    }

    root.__mgSchedValidate = function () {
      // En modo simulado, usamos los valores que el server inyectó (no la hora real)
      var nowChileHour, todayChile;
      if (config.simulated) {
        nowChileHour = config.nowHourChile;
        todayChile = config.todayChile;
      } else {
        nowChileHour = parseInt(new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Santiago',
          hour: 'numeric',
          hour12: false
        }).format(new Date()), 10);
        if (isNaN(nowChileHour)) nowChileHour = 0;
        todayChile = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Santiago' });
      }

      var c = comunaSel.value || '';
      var d = dateInput.value || '';
      var s = slotInput.value || '';

      if (!c) { showError('Selecciona una comuna.'); comunaSel.classList.add('is-error'); comunaSel.focus(); return false; }
      if (!d) { showError('Selecciona una fecha.'); return false; }
      if (!s) { showError('Selecciona un horario.'); return false; }

      if (d === todayChile && s.indexOf('Tarde') !== -1 && nowChileHour >= config.cutoff) {
        showError('La hora de corte ya pasó. Selecciona otro día.');
        return false;
      }
      if (d === todayChile && s.indexOf('Mañana') !== -1) {
        showError('La opción Mañana no aplica para hoy. Selecciona otro día.');
        return false;
      }
      hideMessage();
      return true;
    };
  }

  function updateCart(key, val) {
    var body = { attributes: {} };
    body.attributes[key] = val;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).catch(function () {});
  }

  function isCheckoutTrigger(el) {
    if (!el) return false;
    if (el.id === 'checkout') return true;
    if (el.name === 'checkout') return true;
    var name = el.getAttribute && el.getAttribute('name');
    if (name === 'checkout') return true;
    var href = el.href || '';
    if (href.indexOf('/checkout') !== -1) return true;
    return false;
  }

  function getActiveScheduler() {
    var schedulers = document.querySelectorAll('[data-mg-sched]');
    if (!schedulers.length) return null;
    for (var i = 0; i < schedulers.length; i++) {
      if (schedulers[i].offsetParent !== null) return schedulers[i];
    }
    return schedulers[0];
  }

  document.addEventListener('click', function (e) {
    if (window.__mgSchedSkipOnce) { window.__mgSchedSkipOnce = false; return; }
    var t = e.target;
    while (t && t !== document.body) {
      if (isCheckoutTrigger(t)) {
        var sched = getActiveScheduler();
        if (sched && sched.__mgSchedValidate && !sched.__mgSchedValidate()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          sched.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
      }
      t = t.parentElement;
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (window.__mgSchedSkipOnce) { window.__mgSchedSkipOnce = false; return; }
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.action || '';
    if (action.indexOf('/checkout') === -1) return;

    var sched = getActiveScheduler();
    if (sched && sched.__mgSchedValidate && !sched.__mgSchedValidate()) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      sched.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
  }, true);

  function initAll() {
    document.querySelectorAll('[data-mg-sched]').forEach(initScheduler);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init después de cualquier re-render del cart drawer / cart page
  var debounce;
  var obs = new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(initAll, 200);
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
